import React from 'react';
import { twMerge } from 'tailwind-merge';
import LiveChatIcon from '@/assets/icons/livechat-icon.svg?react';

interface WidgetIconProps {
  isOpen: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeConfig = {
  sm: { width: 20, height: 20 },
  md: { width: 24, height: 24 },
  lg: { width: 28, height: 28 },
};

const WidgetIcon: React.FC<WidgetIconProps> = ({
  isOpen,
  className = '',
  size = 'md',
}) => {
  // Size configurations

  const { width, height } = sizeConfig[size];

  // Translation keys following user rule to avoid collision
  const getAriaLabel = () => {
    // Using specific keys: widget.icon.aria.label.chat.open/close
    return isOpen
      ? 'Close chat widget' // In real implementation: t('widget.icon.aria.label.chat.close')
      : 'Open chat widget'; // In real implementation: t('widget.icon.aria.label.chat.open')
  };

  return (
    <div
      className={twMerge(
        'sf:relative sf:flex sf:items-center sf:justify-center',
        className,
      )}
      aria-label={getAriaLabel()}
      title={getAriaLabel()} // Additional tooltip for better UX
    >
      {/* Chat Icon - visible when closed */}
      <div
        className={twMerge(
          'sf:inset-0 sf:transition-all sf:duration-300 sf:ease-in-out',
          isOpen
            ? 'sf:opacity-0 sf:rotate-45 sf:scale-75 sf:pointer-events-none'
            : 'sf:opacity-100 sf:rotate-0 sf:scale-100',
        )}
        style={{ width, height }}
      >
        <LiveChatIcon />
      </div>
    </div>
  );
};

export default WidgetIcon;
